import { useState } from 'react';
import { t } from '@/i18n';
import { PageLayout } from '@/components/layout/PageLayout';
import { Card, CardContent } from '@/components/ui/card';
import { ShiftFindings } from '@/components/branch/ShiftFindings';
import { Badge } from '@/components/ui/badge';
import { ScanSearch } from 'lucide-react';
import { cn } from '@/lib/utils';

const GIF_SRC = `${process.env.PUBLIC_URL || ''}/Untitled%20video.gif`;

export default function DetekceVetvi() {
  const [detectedCount] = useState(3);

  return (
    <PageLayout title={t('branchDetection.title')} concept>
      <div className="space-y-6">
        <div>
          <h2 className="text-2xl font-bold tracking-tight mb-2 flex items-center gap-2">
            <ScanSearch className="h-7 w-7 text-green-600" />
            {t('branchDetection.title')}
          </h2>
          <p className="text-muted-foreground max-w-2xl">
            {t('branchDetection.description')}
          </p>
        </div>

        {/* GIF v loopu – dopravník s detekcí větví */}
        <Card className=" overflow-hidden">
          <CardContent className="p-4 sm:p-6">
            <div className="text-sm font-semibold text-muted-foreground mb-3">
              {t('branchDetection.demo')}
            </div>
            <div
              className={cn(
                'relative w-full rounded-lg overflow-hidden',
                'border-2 border-green-500',
                'aspect-video max-w-3xl mx-auto',
                'bg-stone-100 shadow-inner'
              )}
            >
              <img
                src={GIF_SRC}
                alt={t('branchDetection.demo')}
                className="w-full h-full object-cover"
              />
              {/* Overlay label */}
              <div className="absolute bottom-2 left-2 text-[10px] font-medium text-green-700 bg-green-100/90 px-2 py-1 rounded">
                {t('branchDetection.zone')}
              </div>
            </div>

            {/* Mock statistiky */}
            <div className="flex flex-wrap items-center gap-4 mt-4">
              <div className="flex items-center gap-2">
                <span className="text-sm text-muted-foreground">{t('branchDetection.detected')}:</span>
                <Badge variant="secondary" className="font-mono">
                  {detectedCount} {t('branchDetection.branches')}
                </Badge>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-sm text-muted-foreground">{t('branchDetection.accuracy')}:</span>
                <Badge className="bg-green-100 text-green-800 hover:bg-green-100">
                  98%
                </Badge>
              </div>
              <Badge variant="outline" className="text-green-600 border-green-300">
                <span className="w-2 h-2 bg-green-500 rounded-full mr-1.5 animate-pulse" />
                {t('branchDetection.live')}
              </Badge>
            </div>
          </CardContent>
        </Card>

        <ShiftFindings />
      </div>
    </PageLayout>
  );
}
